import { hooks } from "./hookactions"
import { actions } from "./actions"

export let SYSTOTP = { hooks, actions }
